import {Reducer} from 'redux'
import {InvoicesActionTypes, InvoicesState} from './types';
import InvoicesService from "../../services/InvoicesService";

// Type-safe initialState!
const initialState: InvoicesState = {
	list: [],
	customerList: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<InvoicesState> = (state = initialState, action) => {
	switch (action.type) {
		case InvoicesActionTypes.FETCH_ALL_REQUEST: {
			InvoicesService.getAll()
			return { ...state, loading: true }
		}
		case InvoicesActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case InvoicesActionTypes.FETCH_ONE_REQUEST: {
			InvoicesService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case InvoicesActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case InvoicesActionTypes.SAVE_REQUEST: {
			InvoicesService.save(action.payload)
			return { ...state, loading: true }
		}
		case InvoicesActionTypes.SAVE_COMPLETED: {
			let newInvoice = action.payload
			let foundIndex = state.list.findIndex(element => element.id === newInvoice.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case InvoicesActionTypes.DELETE_REQUEST: {
			InvoicesService.delete(action.payload)
			return { ...state, loading: true }
		}
		case InvoicesActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case InvoicesActionTypes.DELETE_MULTIPLE_REQUEST: {
			InvoicesService.deleteInvoices(action.payload)
			return { ...state, loading: true }
		}
		case InvoicesActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case InvoicesActionTypes.INVOICEITEM_SAVE_REQUEST: {
			let {invoiceItem, index}  = action.payload
			InvoicesService.saveInvoiceItem(invoiceItem, index)
			return state
		}
		case InvoicesActionTypes.INVOICEITEM_SAVE_COMPLETED: {
			// todo use index!
			let {invoiceItem, index}  = action.payload
			// let invoiceIndex = state.list.findIndex(element => element.id === invoiceItem.invoiceId)
			// let invoice = state.list[invoiceIndex]
			// let foundIndex = invoice.invoiceItems.findIndex(element => element.amount === invoiceItem.amount &&
			// 	element.price === invoiceItem.price &&
			// 	element.serviceId === invoiceItem.serviceId &&
			// 	element.vat === invoiceItem.vat
			// )
			//
			// if (foundIndex >= 0) {
			// 	invoice.invoiceItems.splice(foundIndex, 1, invoiceItem)
			// 	state.list.splice(invoiceIndex, 1, invoice)
			// }
			//
			// let newList = [...state.list]
			return { ...state }
			// return state
		}
		case InvoicesActionTypes.INVOICEITEM_DELETE_REQUEST: {
			InvoicesService.deleteInvoiceItem(action.payload)
			return state
		}
		case InvoicesActionTypes.INVOICEITEM_DELETE_COMPLETED: {
			let newInvoiceItem = action.payload
			let invoiceIndex = state.list.findIndex(element => element.id === newInvoiceItem.invoiceId)
			let invoice = state.list[invoiceIndex]
			let foundIndex = invoice.invoiceItems.findIndex(element => element.amount === newInvoiceItem.amount &&
				element.price === newInvoiceItem.email &&
				element.serviceId === newInvoiceItem.phone &&
				element.vat === newInvoiceItem.vat
			)
			invoice.invoiceItems.splice(foundIndex, 1)
			state.list.splice(invoiceIndex, 1, invoice)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case InvoicesActionTypes.FETCH_BY_CUSTOMER_REQUEST: {
			InvoicesService.getAllByCustomer(action.payload);
			return state
		}
		case InvoicesActionTypes.FETCH_BY_CUSTOMER_COMPLETED: {
			return { ...state, customerList: action.payload}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as InvoicesReducer}
